/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import * as Types from '../../../../types/dashboard-core-gqlTypes.generated.d';

import { BaseOrganizationFragmentGQLType } from '../../organization/requests/organization.gql.generated';
import { gql } from '@apollo/client';
import { BaseOrganizationFragmentDocGQLType } from '../../organization/requests/organization.gql.generated';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type LoanRecordFragmentGQLType = (
  { __typename?: 'LoanRecord' }
  & Pick<Types.LoanRecordGQLType, 'id' | 'creditFacilityId' | 'borrowerOrganizationId' | 'externalLoanId' | 'name' | 'loanStatus' | 'loanType' | 'isFinal' | 'maturityDate'>
);

export type ShareFundingComponentFragmentGQLType = (
  { __typename?: 'ShareFundingComponent' }
  & Pick<Types.ShareFundingComponentGQLType, 'fundingRequestComponentId' | 'type' | 'requestedAmount' | 'targetFundingDate' | 'postingDate' | 'fundTransferDate' | 'lenderShareId' | 'lenderOrganizationId' | 'projectedInterest'>
);

export type FundingLenderSharesFragmentGQLType = (
  { __typename?: 'FundingLenderShares' }
  & Pick<Types.FundingLenderSharesGQLType, 'lenderShareId' | 'allocationPercent' | 'initialFundingAmount' | 'outstandingBalance' | 'totalAccruedInterest' | 'projectedInterest'>
  & { lenderOrganization: (
    { __typename?: 'BaseOrganization' }
    & BaseOrganizationFragmentGQLType
  ) }
);

export type FundingRequestEntitiesFragmentGQLType = (
  { __typename?: 'FundingRequestEntities' }
  & Pick<Types.FundingRequestEntitiesGQLType, 'fundingRequestId' | 'fundingRequestStatus' | 'fundingRequestType' | 'fundingRequestCreatedAt' | 'totalRequestedAmount' | 'originationDate'>
  & { fundingComponents: Array<(
    { __typename?: 'ShareFundingComponent' }
    & ShareFundingComponentFragmentGQLType
  )> }
);

export type ResolvedLoanFragmentGQLType = (
  { __typename?: 'ResolvedLoan' }
  & Pick<Types.ResolvedLoanGQLType, 'id' | 'externalLoanId' | 'commitmentKey' | 'name' | 'memo' | 'calculatedLoanStatus' | 'loanType'>
  & { dates: (
    { __typename?: 'LoanDatesData' }
    & Pick<Types.LoanDatesDataGQLType, 'originationDate' | 'targetFundingDate' | 'settledDate' | 'maturityDate'>
  ), facility: (
    { __typename?: 'LoanFacilityData' }
    & Pick<Types.LoanFacilityDataGQLType, 'commitmentAmount' | 'creditFacilityId' | 'creditFacilityName' | 'externalFacilityId' | 'loanMechanics'>
  ), funding: (
    { __typename?: 'LoanFundingData' }
    & Pick<Types.LoanFundingDataGQLType, 'commitmentKey' | 'initialFundingAmount' | 'totalOutstandingBalance'>
    & { lenderShares: Array<(
      { __typename?: 'FundingLenderShares' }
      & FundingLenderSharesFragmentGQLType
    )>, requests: Array<(
      { __typename?: 'FundingRequestEntities' }
      & FundingRequestEntitiesFragmentGQLType
    )> }
  ), parties: (
    { __typename?: 'LoanPartiesData' }
    & { borrowerOrganization: (
      { __typename?: 'BaseOrganization' }
      & BaseOrganizationFragmentGQLType
    ), adminAgentOrganization?: Types.Maybe<(
      { __typename?: 'BaseOrganization' }
      & BaseOrganizationFragmentGQLType
    )>, lenderOrganizations: Array<(
      { __typename?: 'BaseOrganization' }
      & BaseOrganizationFragmentGQLType
    )> }
  ), pricing: (
    { __typename?: 'LoanPricing' }
    & Pick<Types.LoanPricingGQLType, 'key' | 'name'>
    & { accrual: (
      { __typename?: 'LoanPricingAccrual' }
      & Pick<Types.LoanPricingAccrualGQLType, 'basis'>
      & { cadence: (
        { __typename?: 'LoanAccrualCadence' }
        & Pick<Types.LoanAccrualCadenceGQLType, 'type'>
      ) }
    ), current: (
      { __typename?: 'LoanInterestRateConfiguration' }
      & Pick<Types.LoanInterestRateConfigurationGQLType, 'effectiveDate' | 'allInRate' | 'weightedAverageMarginRate'>
      & { baseRate: (
        { __typename?: 'LoanInterestRateBaseConfiguration' }
        & Pick<Types.LoanInterestRateBaseConfigurationGQLType, 'type' | 'name' | 'determinationDate' | 'publishedDate' | 'publishedRate' | 'adjustedRate' | 'ceiling' | 'floor' | 'spread'>
      ) }
    ), history: Array<(
      { __typename?: 'LoanInterestRateConfiguration' }
      & Pick<Types.LoanInterestRateConfigurationGQLType, 'effectiveDate' | 'weightedAverageMarginRate'>
      & { baseRate: (
        { __typename?: 'LoanInterestRateBaseConfiguration' }
        & Pick<Types.LoanInterestRateBaseConfigurationGQLType, 'type' | 'name' | 'determinationDate' | 'publishedDate' | 'publishedRate' | 'adjustedRate'>
      ) }
    )>, margins: Array<(
      { __typename?: 'LoanShareMargin' }
      & Pick<Types.LoanShareMarginGQLType, 'organizationId' | 'rate'>
      & { skimFee?: Types.Maybe<(
        { __typename?: 'SkimFee' }
        & Pick<Types.SkimFeeGQLType, 'type' | 'rate'>
      )> }
    )> }
  ), fees: (
    { __typename?: 'LoanFees' }
    & Pick<Types.LoanFeesGQLType, 'projectedInterest' | 'projectedServiceFees'>
    & { accruedInterest: (
      { __typename?: 'AccruedInterestAndFeesSummary' }
      & Pick<Types.AccruedInterestAndFeesSummaryGQLType, 'totalAmount'>
      & { annualAmounts: Array<Types.Maybe<(
        { __typename?: 'AccruedInterestAndFeesAnnualAmounts' }
        & Pick<Types.AccruedInterestAndFeesAnnualAmountsGQLType, 'year' | 'amount'>
      )>> }
    ), accruedServiceFees: (
      { __typename?: 'AccruedInterestAndFeesSummary' }
      & Pick<Types.AccruedInterestAndFeesSummaryGQLType, 'totalAmount'>
      & { annualAmounts: Array<Types.Maybe<(
        { __typename?: 'AccruedInterestAndFeesAnnualAmounts' }
        & Pick<Types.AccruedInterestAndFeesAnnualAmountsGQLType, 'year' | 'amount'>
      )>> }
    ), totalAccruedInterestAndFees: (
      { __typename?: 'AccruedInterestAndFeesSummary' }
      & Pick<Types.AccruedInterestAndFeesSummaryGQLType, 'totalAmount'>
      & { annualAmounts: Array<Types.Maybe<(
        { __typename?: 'AccruedInterestAndFeesAnnualAmounts' }
        & Pick<Types.AccruedInterestAndFeesAnnualAmountsGQLType, 'year' | 'amount'>
      )>> }
    ) }
  ), invoices?: Types.Maybe<(
    { __typename?: 'LoanInvoice' }
    & Pick<Types.LoanInvoiceGQLType, 'nextInvoiceId' | 'nextPaymentDate' | 'mostRecentAccrualEndDate'>
  )>, customerProvided?: Types.Maybe<(
    { __typename?: 'CustomerProvided' }
    & { escrow?: Types.Maybe<(
      { __typename?: 'CustomerProvidedEscrow' }
      & Pick<Types.CustomerProvidedEscrowGQLType, 'amount'>
    )>, status?: Types.Maybe<(
      { __typename?: 'CustomerProvidedStatus' }
      & Pick<Types.CustomerProvidedStatusGQLType, 'code' | 'name'>
    )>, servicer?: Types.Maybe<(
      { __typename?: 'CustomerProvidedServicer' }
      & Pick<Types.CustomerProvidedServicerGQLType, 'name'>
    )> }
  )> }
);

export type SummarizedLoanFragmentGQLType = (
  { __typename?: 'SummarizedLoan' }
  & Pick<Types.SummarizedLoanGQLType, 'id' | 'externalLoanId' | 'name' | 'calculatedLoanStatus' | 'loanType' | 'isFinal' | 'originationDate' | 'nextPaymentDate' | 'maturityDate' | 'creditFacilityId' | 'creditFacilityName' | 'externalFacilityId'>
  & { borrowerOrganization: (
    { __typename?: 'BaseOrganization' }
    & BaseOrganizationFragmentGQLType
  ), lenderOrganizations: Array<(
    { __typename?: 'BaseOrganization' }
    & BaseOrganizationFragmentGQLType
  )> }
);

export type LenderShareReportFragmentGQLType = (
  { __typename?: 'LenderShareReport' }
  & Pick<Types.LenderShareReportGQLType, 'id' | 'creditFacilityId' | 'lenderShareId' | 'fundingRequestComponentId' | 'reportType' | 'reportName' | 'reportingDate' | 'version' | 'isPreview' | 'capitalProviderName'>
);

export type BatchSettlementReportFragmentGQLType = (
  { __typename?: 'BatchSettlementReport' }
  & Pick<Types.BatchSettlementReportGQLType, 'id' | 'creditFacilityId' | 'batchSettlementId' | 'reportType' | 'reportName' | 'reportingDate' | 'version' | 'isPreview'>
);

export type BatchSettlementFragmentGQLType = (
  { __typename?: 'BatchSettlement' }
  & Pick<Types.BatchSettlementGQLType, 'id' | 'creditFacilityId' | 'capitalProviderId' | 'startDate' | 'endDate' | 'capitalProviderName' | 'created_at'>
  & { loans: Array<(
    { __typename?: 'LoanNameAndExternalId' }
    & Pick<Types.LoanNameAndExternalIdGQLType, 'loanId' | 'loanName' | 'externalLoanId'>
  )>, report?: Types.Maybe<(
    { __typename?: 'BatchSettlementReport' }
    & BatchSettlementReportFragmentGQLType
  )> }
);

export type GetCreditFacilitiesLoanRecordsQueryVariablesGQLType = Types.Exact<{
  organizationId: Types.Scalars['UUID'];
}>;


export type GetCreditFacilitiesLoanRecordsQueryGQLType = (
  { __typename?: 'Query' }
  & { creditFacilities: Array<(
    { __typename?: 'CreditFacility' }
    & Pick<Types.CreditFacilityGQLType, 'id' | 'slug' | 'name'>
    & { loanRecords: Array<(
      { __typename?: 'LoanRecord' }
      & Pick<Types.LoanRecordGQLType, 'id' | 'name' | 'externalLoanId'>
    )> }
  )> }
);

export type GetCreditFacilityFullLoansQueryVariablesGQLType = Types.Exact<{
  creditFacilityId: Types.Scalars['UUID'];
}>;


export type GetCreditFacilityFullLoansQueryGQLType = (
  { __typename?: 'Query' }
  & { creditFacility: (
    { __typename?: 'CreditFacility' }
    & Pick<Types.CreditFacilityGQLType, 'id' | 'slug' | 'name'>
    & { loans: Array<(
      { __typename?: 'ResolvedLoan' }
      & ResolvedLoanFragmentGQLType
    )> }
  ) }
);

export type GetCreditFacilitiesFullLoansQueryVariablesGQLType = Types.Exact<{
  organizationId: Types.Scalars['UUID'];
}>;


export type GetCreditFacilitiesFullLoansQueryGQLType = (
  { __typename?: 'Query' }
  & { creditFacilities: Array<(
    { __typename?: 'CreditFacility' }
    & Pick<Types.CreditFacilityGQLType, 'id' | 'slug' | 'name'>
    & { loans: Array<(
      { __typename?: 'ResolvedLoan' }
      & ResolvedLoanFragmentGQLType
    )> }
  )> }
);

export type GetLoanRecordByIdQueryVariablesGQLType = Types.Exact<{
  loanId?: Types.Maybe<Types.Scalars['UUID']>;
  externalLoanId?: Types.Maybe<Types.Scalars['UUID']>;
  creditFacilityId?: Types.Maybe<Types.Scalars['UUID']>;
}>;


export type GetLoanRecordByIdQueryGQLType = (
  { __typename?: 'Query' }
  & { loan: (
    { __typename?: 'LoanRecord' }
    & LoanRecordFragmentGQLType
  ) }
);

export type GetLoanRecordsByMetadataQueryVariablesGQLType = Types.Exact<{
  filterParams: Types.LoanMetadataFilterParamsGQLType;
}>;


export type GetLoanRecordsByMetadataQueryGQLType = (
  { __typename?: 'Query' }
  & { loans: Array<(
    { __typename?: 'LoanRecord' }
    & LoanRecordFragmentGQLType
  )> }
);

export type GetResolvedLoanByIdQueryVariablesGQLType = Types.Exact<{
  loanId: Types.Scalars['UUID'];
}>;


export type GetResolvedLoanByIdQueryGQLType = (
  { __typename?: 'Query' }
  & { loan: (
    { __typename?: 'ResolvedLoan' }
    & ResolvedLoanFragmentGQLType
  ) }
);

export type GetLoanRecordsByFundingRequestQueryVariablesGQLType = Types.Exact<{
  fundingRequestId: Types.Scalars['UUID'];
}>;


export type GetLoanRecordsByFundingRequestQueryGQLType = (
  { __typename?: 'Query' }
  & { loans: Array<(
    { __typename?: 'LoanRecord' }
    & LoanRecordFragmentGQLType
  )> }
);

export type GetResolvedLoansByFundingRequestQueryVariablesGQLType = Types.Exact<{
  fundingRequestId: Types.Scalars['UUID'];
}>;


export type GetResolvedLoansByFundingRequestQueryGQLType = (
  { __typename?: 'Query' }
  & { loans: Array<(
    { __typename?: 'ResolvedLoan' }
    & ResolvedLoanFragmentGQLType
  )> }
);

export type GetLoanRecordByFundingRequestAndCommitmentKeyQueryVariablesGQLType = Types.Exact<{
  fundingRequestId: Types.Scalars['UUID'];
  commitmentKey: Types.Scalars['String'];
}>;


export type GetLoanRecordByFundingRequestAndCommitmentKeyQueryGQLType = (
  { __typename?: 'Query' }
  & { loan?: Types.Maybe<(
    { __typename?: 'LoanRecord' }
    & LoanRecordFragmentGQLType
  )> }
);

export type GetResolvedLoanByFundingRequestAndCommitmentKeyQueryVariablesGQLType = Types.Exact<{
  fundingRequestId: Types.Scalars['UUID'];
  commitmentKey: Types.Scalars['String'];
}>;


export type GetResolvedLoanByFundingRequestAndCommitmentKeyQueryGQLType = (
  { __typename?: 'Query' }
  & { loan?: Types.Maybe<(
    { __typename?: 'ResolvedLoan' }
    & ResolvedLoanFragmentGQLType
  )> }
);

export type GetAggregateLoansMetadataQueryVariablesGQLType = Types.Exact<{
  filterParams: Types.LoanMetadataFilterParamsGQLType;
}>;


export type GetAggregateLoansMetadataQueryGQLType = (
  { __typename?: 'Query' }
  & { results: (
    { __typename?: 'LoanAggregateMetadata' }
    & Pick<Types.LoanAggregateMetadataGQLType, 'totalOutstandingBalance' | 'totalAccruedInterest' | 'totalAccruedServiceFees'>
  ) }
);

export type GetSummarizedLoansQueryVariablesGQLType = Types.Exact<{
  filterParams: Types.LoanMetadataFilterParamsGQLType;
}>;


export type GetSummarizedLoansQueryGQLType = (
  { __typename?: 'Query' }
  & { loans: Array<(
    { __typename?: 'SummarizedLoan' }
    & SummarizedLoanFragmentGQLType
  )> }
);

export type GetCurrentLiabilityAccountsAndAccrualsForLoanQueryVariablesGQLType = Types.Exact<{
  loanId: Types.Scalars['UUID'];
  accrualStartDate: Types.Scalars['FullDateStr'];
  accrualEndDate: Types.Scalars['FullDateStr'];
  inclusiveOfAccrualEndDate: Types.Scalars['Boolean'];
}>;


export type GetCurrentLiabilityAccountsAndAccrualsForLoanQueryGQLType = (
  { __typename?: 'Query' }
  & { accounts: Array<(
    { __typename?: 'LoanAccountAccrualObject' }
    & Pick<Types.LoanAccountAccrualObjectGQLType, 'actualAccruedAmount' | 'projectedAccruedAmount' | 'totalAccruedAmount'>
    & { tAccount: (
      { __typename?: 'TAccount' }
      & Pick<Types.TAccountGQLType, 'id' | 'tAccount' | 'creditFacilityId' | 'organizationId'>
    ) }
  )> }
);

export type GetLenderShareReportsQueryVariablesGQLType = Types.Exact<{
  lenderShareId: Types.Scalars['UUID'];
  fundingRequestComponentId: Types.Scalars['UUID'];
}>;


export type GetLenderShareReportsQueryGQLType = (
  { __typename?: 'Query' }
  & { reports: Array<(
    { __typename?: 'LenderShareReport' }
    & LenderShareReportFragmentGQLType
  )> }
);

export type GetLenderShareReportsForLoanQueryVariablesGQLType = Types.Exact<{
  loanId: Types.Scalars['UUID'];
  fundingRequestId: Types.Scalars['UUID'];
}>;


export type GetLenderShareReportsForLoanQueryGQLType = (
  { __typename?: 'Query' }
  & { reports: Array<(
    { __typename?: 'LenderShareReport' }
    & LenderShareReportFragmentGQLType
  )> }
);

export type GetEarliestOriginationDateForLoansQueryVariablesGQLType = Types.Exact<{
  creditFacilityId: Types.Scalars['UUID'];
  loanIds: Array<Types.Scalars['UUID']> | Types.Scalars['UUID'];
}>;


export type GetEarliestOriginationDateForLoansQueryGQLType = (
  { __typename?: 'Query' }
  & { earliestOriginationDate: Types.QueryGQLType['getEarliestOriginationDateForLoans'] }
);

export type GetBatchSettlementsForCreditFacilityQueryVariablesGQLType = Types.Exact<{
  creditFacilityId: Types.Scalars['UUID'];
  lenderIds?: Types.Maybe<Array<Types.Scalars['UUID']> | Types.Scalars['UUID']>;
  loanIds?: Types.Maybe<Array<Types.Scalars['UUID']> | Types.Scalars['UUID']>;
}>;


export type GetBatchSettlementsForCreditFacilityQueryGQLType = (
  { __typename?: 'Query' }
  & { settlements: Array<(
    { __typename?: 'BatchSettlement' }
    & BatchSettlementFragmentGQLType
  )> }
);

export type MarkLenderShareComponentFundTransferDateMutationVariablesGQLType = Types.Exact<{
  lenderShareId: Types.Scalars['UUID'];
  fundingRequestComponentId: Types.Scalars['UUID'];
  fundTransferDate?: Types.Maybe<Types.Scalars['FullDateStr']>;
}>;


export type MarkLenderShareComponentFundTransferDateMutationGQLType = (
  { __typename?: 'Mutation' }
  & Pick<Types.MutationGQLType, 'markLenderShareComponentFundTransferDate'>
);

export type UpdateLoanExternalLoanIdMutationVariablesGQLType = Types.Exact<{
  loanId: Types.Scalars['UUID'];
  newExternalLoanId?: Types.Maybe<Types.Scalars['String']>;
}>;


export type UpdateLoanExternalLoanIdMutationGQLType = (
  { __typename?: 'Mutation' }
  & { updateLoanExternalLoanId: (
    { __typename?: 'LoanRecord' }
    & LoanRecordFragmentGQLType
  ) }
);

export type CreateBatchSettlementMutationVariablesGQLType = Types.Exact<{
  creditFacilityId: Types.Scalars['UUID'];
  lenderIds: Array<Types.Scalars['UUID']> | Types.Scalars['UUID'];
  loanIds: Array<Types.Scalars['UUID']> | Types.Scalars['UUID'];
  startDate: Types.Scalars['FullDateStr'];
  endDate: Types.Scalars['FullDateStr'];
}>;


export type CreateBatchSettlementMutationGQLType = (
  { __typename?: 'Mutation' }
  & { createBatchSettlement: Array<(
    { __typename?: 'BatchSettlementSubmissionResult' }
    & Pick<Types.BatchSettlementSubmissionResultGQLType, 'batchSettlementId' | 'workleaseId'>
  )> }
);

export const LoanRecordFragmentDocGQLType = gql`
    fragment LoanRecord on LoanRecord {
  id
  creditFacilityId
  borrowerOrganizationId
  externalLoanId
  name
  loanStatus
  loanType
  isFinal
  maturityDate
}
    `;
export const FundingLenderSharesFragmentDocGQLType = gql`
    fragment FundingLenderShares on FundingLenderShares {
  lenderShareId
  lenderOrganization {
    ...BaseOrganization
  }
  allocationPercent
  initialFundingAmount
  outstandingBalance
  totalAccruedInterest
  projectedInterest
}
    ${BaseOrganizationFragmentDocGQLType}`;
export const ShareFundingComponentFragmentDocGQLType = gql`
    fragment ShareFundingComponent on ShareFundingComponent {
  fundingRequestComponentId
  type
  requestedAmount
  targetFundingDate
  postingDate
  fundTransferDate
  lenderShareId
  lenderOrganizationId
  projectedInterest
}
    `;
export const FundingRequestEntitiesFragmentDocGQLType = gql`
    fragment FundingRequestEntities on FundingRequestEntities {
  fundingRequestId
  fundingRequestStatus
  fundingRequestType
  fundingRequestCreatedAt
  totalRequestedAmount
  originationDate
  fundingComponents {
    ...ShareFundingComponent
  }
}
    ${ShareFundingComponentFragmentDocGQLType}`;
export const ResolvedLoanFragmentDocGQLType = gql`
    fragment ResolvedLoan on ResolvedLoan {
  id
  externalLoanId
  commitmentKey
  name
  memo
  calculatedLoanStatus
  loanType
  dates {
    originationDate
    targetFundingDate
    settledDate
    maturityDate
  }
  facility {
    commitmentAmount
    creditFacilityId
    creditFacilityName
    externalFacilityId
    loanMechanics
  }
  funding {
    commitmentKey
    initialFundingAmount
    totalOutstandingBalance
    lenderShares {
      ...FundingLenderShares
    }
    requests {
      ...FundingRequestEntities
    }
  }
  parties {
    borrowerOrganization {
      ...BaseOrganization
    }
    adminAgentOrganization {
      ...BaseOrganization
    }
    lenderOrganizations {
      ...BaseOrganization
    }
  }
  pricing {
    key
    name
    accrual {
      basis
      cadence {
        type
      }
    }
    current {
      effectiveDate
      allInRate
      baseRate {
        type
        name
        determinationDate
        publishedDate
        publishedRate
        adjustedRate
        ceiling
        floor
        spread
      }
      weightedAverageMarginRate
    }
    history {
      effectiveDate
      baseRate {
        type
        name
        determinationDate
        publishedDate
        publishedRate
        adjustedRate
      }
      weightedAverageMarginRate
    }
    margins {
      organizationId
      rate
      skimFee {
        type
        rate
      }
    }
  }
  fees {
    accruedInterest {
      totalAmount
      annualAmounts {
        year
        amount
      }
    }
    projectedInterest
    accruedServiceFees {
      totalAmount
      annualAmounts {
        year
        amount
      }
    }
    projectedServiceFees
    totalAccruedInterestAndFees {
      totalAmount
      annualAmounts {
        year
        amount
      }
    }
  }
  invoices {
    nextInvoiceId
    nextPaymentDate
    mostRecentAccrualEndDate
  }
  customerProvided {
    escrow {
      amount
    }
    status {
      code
      name
    }
    servicer {
      name
    }
  }
}
    ${FundingLenderSharesFragmentDocGQLType}
${FundingRequestEntitiesFragmentDocGQLType}
${BaseOrganizationFragmentDocGQLType}`;
export const SummarizedLoanFragmentDocGQLType = gql`
    fragment SummarizedLoan on SummarizedLoan {
  id
  externalLoanId
  name
  calculatedLoanStatus
  loanType
  isFinal
  originationDate
  nextPaymentDate
  maturityDate
  creditFacilityId
  creditFacilityName
  externalFacilityId
  borrowerOrganization {
    ...BaseOrganization
  }
  lenderOrganizations {
    ...BaseOrganization
  }
}
    ${BaseOrganizationFragmentDocGQLType}`;
export const LenderShareReportFragmentDocGQLType = gql`
    fragment LenderShareReport on LenderShareReport {
  id
  creditFacilityId
  lenderShareId
  fundingRequestComponentId
  reportType
  reportName
  reportingDate
  version
  isPreview
  capitalProviderName
}
    `;
export const BatchSettlementReportFragmentDocGQLType = gql`
    fragment BatchSettlementReport on BatchSettlementReport {
  id
  creditFacilityId
  batchSettlementId
  reportType
  reportName
  reportingDate
  version
  isPreview
}
    `;
export const BatchSettlementFragmentDocGQLType = gql`
    fragment BatchSettlement on BatchSettlement {
  id
  creditFacilityId
  capitalProviderId
  startDate
  endDate
  capitalProviderName
  loans {
    loanId
    loanName
    externalLoanId
  }
  report {
    ...BatchSettlementReport
  }
  created_at
}
    ${BatchSettlementReportFragmentDocGQLType}`;
export const GetCreditFacilitiesLoanRecordsDocumentGQLType = gql`
    query GetCreditFacilitiesLoanRecords($organizationId: UUID!) {
  creditFacilities(organizationId: $organizationId) {
    id
    slug
    name
    loanRecords {
      id
      name
      externalLoanId
    }
  }
}
    `;

/**
 * __useGetCreditFacilitiesLoanRecordsQuery__
 *
 * To run a query within a React component, call `useGetCreditFacilitiesLoanRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditFacilitiesLoanRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditFacilitiesLoanRecordsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetCreditFacilitiesLoanRecordsQuery(baseOptions: Apollo.QueryHookOptions<GetCreditFacilitiesLoanRecordsQueryGQLType, GetCreditFacilitiesLoanRecordsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditFacilitiesLoanRecordsQueryGQLType, GetCreditFacilitiesLoanRecordsQueryVariablesGQLType>(GetCreditFacilitiesLoanRecordsDocumentGQLType, options);
      }
export function useGetCreditFacilitiesLoanRecordsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditFacilitiesLoanRecordsQueryGQLType, GetCreditFacilitiesLoanRecordsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditFacilitiesLoanRecordsQueryGQLType, GetCreditFacilitiesLoanRecordsQueryVariablesGQLType>(GetCreditFacilitiesLoanRecordsDocumentGQLType, options);
        }
export type GetCreditFacilitiesLoanRecordsQueryHookResult = ReturnType<typeof useGetCreditFacilitiesLoanRecordsQuery>;
export type GetCreditFacilitiesLoanRecordsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditFacilitiesLoanRecordsLazyQueryGQLType>;
export type GetCreditFacilitiesLoanRecordsQueryResultGQLType = Apollo.QueryResult<GetCreditFacilitiesLoanRecordsQueryGQLType, GetCreditFacilitiesLoanRecordsQueryVariablesGQLType>;
export const GetCreditFacilityFullLoansDocumentGQLType = gql`
    query GetCreditFacilityFullLoans($creditFacilityId: UUID!) {
  creditFacility(creditFacilityId: $creditFacilityId) {
    id
    slug
    name
    loans {
      ...ResolvedLoan
    }
  }
}
    ${ResolvedLoanFragmentDocGQLType}`;

/**
 * __useGetCreditFacilityFullLoansQuery__
 *
 * To run a query within a React component, call `useGetCreditFacilityFullLoansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditFacilityFullLoansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditFacilityFullLoansQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetCreditFacilityFullLoansQuery(baseOptions: Apollo.QueryHookOptions<GetCreditFacilityFullLoansQueryGQLType, GetCreditFacilityFullLoansQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditFacilityFullLoansQueryGQLType, GetCreditFacilityFullLoansQueryVariablesGQLType>(GetCreditFacilityFullLoansDocumentGQLType, options);
      }
export function useGetCreditFacilityFullLoansLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditFacilityFullLoansQueryGQLType, GetCreditFacilityFullLoansQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditFacilityFullLoansQueryGQLType, GetCreditFacilityFullLoansQueryVariablesGQLType>(GetCreditFacilityFullLoansDocumentGQLType, options);
        }
export type GetCreditFacilityFullLoansQueryHookResult = ReturnType<typeof useGetCreditFacilityFullLoansQuery>;
export type GetCreditFacilityFullLoansLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditFacilityFullLoansLazyQueryGQLType>;
export type GetCreditFacilityFullLoansQueryResultGQLType = Apollo.QueryResult<GetCreditFacilityFullLoansQueryGQLType, GetCreditFacilityFullLoansQueryVariablesGQLType>;
export const GetCreditFacilitiesFullLoansDocumentGQLType = gql`
    query GetCreditFacilitiesFullLoans($organizationId: UUID!) {
  creditFacilities(organizationId: $organizationId) {
    id
    slug
    name
    loans {
      ...ResolvedLoan
    }
  }
}
    ${ResolvedLoanFragmentDocGQLType}`;

/**
 * __useGetCreditFacilitiesFullLoansQuery__
 *
 * To run a query within a React component, call `useGetCreditFacilitiesFullLoansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditFacilitiesFullLoansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditFacilitiesFullLoansQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetCreditFacilitiesFullLoansQuery(baseOptions: Apollo.QueryHookOptions<GetCreditFacilitiesFullLoansQueryGQLType, GetCreditFacilitiesFullLoansQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditFacilitiesFullLoansQueryGQLType, GetCreditFacilitiesFullLoansQueryVariablesGQLType>(GetCreditFacilitiesFullLoansDocumentGQLType, options);
      }
export function useGetCreditFacilitiesFullLoansLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditFacilitiesFullLoansQueryGQLType, GetCreditFacilitiesFullLoansQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditFacilitiesFullLoansQueryGQLType, GetCreditFacilitiesFullLoansQueryVariablesGQLType>(GetCreditFacilitiesFullLoansDocumentGQLType, options);
        }
export type GetCreditFacilitiesFullLoansQueryHookResult = ReturnType<typeof useGetCreditFacilitiesFullLoansQuery>;
export type GetCreditFacilitiesFullLoansLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditFacilitiesFullLoansLazyQueryGQLType>;
export type GetCreditFacilitiesFullLoansQueryResultGQLType = Apollo.QueryResult<GetCreditFacilitiesFullLoansQueryGQLType, GetCreditFacilitiesFullLoansQueryVariablesGQLType>;
export const GetLoanRecordByIdDocumentGQLType = gql`
    query getLoanRecordById($loanId: UUID, $externalLoanId: UUID, $creditFacilityId: UUID) {
  loan: getLoanRecordById(
    loanId: $loanId
    externalLoanId: $externalLoanId
    creditFacilityId: $creditFacilityId
  ) {
    ...LoanRecord
  }
}
    ${LoanRecordFragmentDocGQLType}`;

/**
 * __useGetLoanRecordByIdQuery__
 *
 * To run a query within a React component, call `useGetLoanRecordByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanRecordByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanRecordByIdQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      externalLoanId: // value for 'externalLoanId'
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetLoanRecordByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetLoanRecordByIdQueryGQLType, GetLoanRecordByIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanRecordByIdQueryGQLType, GetLoanRecordByIdQueryVariablesGQLType>(GetLoanRecordByIdDocumentGQLType, options);
      }
export function useGetLoanRecordByIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanRecordByIdQueryGQLType, GetLoanRecordByIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanRecordByIdQueryGQLType, GetLoanRecordByIdQueryVariablesGQLType>(GetLoanRecordByIdDocumentGQLType, options);
        }
export type GetLoanRecordByIdQueryHookResult = ReturnType<typeof useGetLoanRecordByIdQuery>;
export type GetLoanRecordByIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLoanRecordByIdLazyQueryGQLType>;
export type GetLoanRecordByIdQueryResultGQLType = Apollo.QueryResult<GetLoanRecordByIdQueryGQLType, GetLoanRecordByIdQueryVariablesGQLType>;
export const GetLoanRecordsByMetadataDocumentGQLType = gql`
    query getLoanRecordsByMetadata($filterParams: LoanMetadataFilterParams!) {
  loans: getLoanRecordsByMetadata(filterParams: $filterParams) {
    ...LoanRecord
  }
}
    ${LoanRecordFragmentDocGQLType}`;

/**
 * __useGetLoanRecordsByMetadataQuery__
 *
 * To run a query within a React component, call `useGetLoanRecordsByMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanRecordsByMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanRecordsByMetadataQuery({
 *   variables: {
 *      filterParams: // value for 'filterParams'
 *   },
 * });
 */
export function useGetLoanRecordsByMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetLoanRecordsByMetadataQueryGQLType, GetLoanRecordsByMetadataQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanRecordsByMetadataQueryGQLType, GetLoanRecordsByMetadataQueryVariablesGQLType>(GetLoanRecordsByMetadataDocumentGQLType, options);
      }
export function useGetLoanRecordsByMetadataLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanRecordsByMetadataQueryGQLType, GetLoanRecordsByMetadataQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanRecordsByMetadataQueryGQLType, GetLoanRecordsByMetadataQueryVariablesGQLType>(GetLoanRecordsByMetadataDocumentGQLType, options);
        }
export type GetLoanRecordsByMetadataQueryHookResult = ReturnType<typeof useGetLoanRecordsByMetadataQuery>;
export type GetLoanRecordsByMetadataLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLoanRecordsByMetadataLazyQueryGQLType>;
export type GetLoanRecordsByMetadataQueryResultGQLType = Apollo.QueryResult<GetLoanRecordsByMetadataQueryGQLType, GetLoanRecordsByMetadataQueryVariablesGQLType>;
export const GetResolvedLoanByIdDocumentGQLType = gql`
    query getResolvedLoanById($loanId: UUID!) {
  loan: getResolvedLoanById(loanId: $loanId) {
    ...ResolvedLoan
  }
}
    ${ResolvedLoanFragmentDocGQLType}`;

/**
 * __useGetResolvedLoanByIdQuery__
 *
 * To run a query within a React component, call `useGetResolvedLoanByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResolvedLoanByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResolvedLoanByIdQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *   },
 * });
 */
export function useGetResolvedLoanByIdQuery(baseOptions: Apollo.QueryHookOptions<GetResolvedLoanByIdQueryGQLType, GetResolvedLoanByIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResolvedLoanByIdQueryGQLType, GetResolvedLoanByIdQueryVariablesGQLType>(GetResolvedLoanByIdDocumentGQLType, options);
      }
export function useGetResolvedLoanByIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetResolvedLoanByIdQueryGQLType, GetResolvedLoanByIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResolvedLoanByIdQueryGQLType, GetResolvedLoanByIdQueryVariablesGQLType>(GetResolvedLoanByIdDocumentGQLType, options);
        }
export type GetResolvedLoanByIdQueryHookResult = ReturnType<typeof useGetResolvedLoanByIdQuery>;
export type GetResolvedLoanByIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetResolvedLoanByIdLazyQueryGQLType>;
export type GetResolvedLoanByIdQueryResultGQLType = Apollo.QueryResult<GetResolvedLoanByIdQueryGQLType, GetResolvedLoanByIdQueryVariablesGQLType>;
export const GetLoanRecordsByFundingRequestDocumentGQLType = gql`
    query getLoanRecordsByFundingRequest($fundingRequestId: UUID!) {
  loans: getLoanRecordsByFundingRequest(fundingRequestId: $fundingRequestId) {
    ...LoanRecord
  }
}
    ${LoanRecordFragmentDocGQLType}`;

/**
 * __useGetLoanRecordsByFundingRequestQuery__
 *
 * To run a query within a React component, call `useGetLoanRecordsByFundingRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanRecordsByFundingRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanRecordsByFundingRequestQuery({
 *   variables: {
 *      fundingRequestId: // value for 'fundingRequestId'
 *   },
 * });
 */
export function useGetLoanRecordsByFundingRequestQuery(baseOptions: Apollo.QueryHookOptions<GetLoanRecordsByFundingRequestQueryGQLType, GetLoanRecordsByFundingRequestQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanRecordsByFundingRequestQueryGQLType, GetLoanRecordsByFundingRequestQueryVariablesGQLType>(GetLoanRecordsByFundingRequestDocumentGQLType, options);
      }
export function useGetLoanRecordsByFundingRequestLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanRecordsByFundingRequestQueryGQLType, GetLoanRecordsByFundingRequestQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanRecordsByFundingRequestQueryGQLType, GetLoanRecordsByFundingRequestQueryVariablesGQLType>(GetLoanRecordsByFundingRequestDocumentGQLType, options);
        }
export type GetLoanRecordsByFundingRequestQueryHookResult = ReturnType<typeof useGetLoanRecordsByFundingRequestQuery>;
export type GetLoanRecordsByFundingRequestLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLoanRecordsByFundingRequestLazyQueryGQLType>;
export type GetLoanRecordsByFundingRequestQueryResultGQLType = Apollo.QueryResult<GetLoanRecordsByFundingRequestQueryGQLType, GetLoanRecordsByFundingRequestQueryVariablesGQLType>;
export const GetResolvedLoansByFundingRequestDocumentGQLType = gql`
    query getResolvedLoansByFundingRequest($fundingRequestId: UUID!) {
  loans: getResolvedLoansByFundingRequest(fundingRequestId: $fundingRequestId) {
    ...ResolvedLoan
  }
}
    ${ResolvedLoanFragmentDocGQLType}`;

/**
 * __useGetResolvedLoansByFundingRequestQuery__
 *
 * To run a query within a React component, call `useGetResolvedLoansByFundingRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResolvedLoansByFundingRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResolvedLoansByFundingRequestQuery({
 *   variables: {
 *      fundingRequestId: // value for 'fundingRequestId'
 *   },
 * });
 */
export function useGetResolvedLoansByFundingRequestQuery(baseOptions: Apollo.QueryHookOptions<GetResolvedLoansByFundingRequestQueryGQLType, GetResolvedLoansByFundingRequestQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResolvedLoansByFundingRequestQueryGQLType, GetResolvedLoansByFundingRequestQueryVariablesGQLType>(GetResolvedLoansByFundingRequestDocumentGQLType, options);
      }
export function useGetResolvedLoansByFundingRequestLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetResolvedLoansByFundingRequestQueryGQLType, GetResolvedLoansByFundingRequestQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResolvedLoansByFundingRequestQueryGQLType, GetResolvedLoansByFundingRequestQueryVariablesGQLType>(GetResolvedLoansByFundingRequestDocumentGQLType, options);
        }
export type GetResolvedLoansByFundingRequestQueryHookResult = ReturnType<typeof useGetResolvedLoansByFundingRequestQuery>;
export type GetResolvedLoansByFundingRequestLazyQueryGQLTypeHookResult = ReturnType<typeof useGetResolvedLoansByFundingRequestLazyQueryGQLType>;
export type GetResolvedLoansByFundingRequestQueryResultGQLType = Apollo.QueryResult<GetResolvedLoansByFundingRequestQueryGQLType, GetResolvedLoansByFundingRequestQueryVariablesGQLType>;
export const GetLoanRecordByFundingRequestAndCommitmentKeyDocumentGQLType = gql`
    query getLoanRecordByFundingRequestAndCommitmentKey($fundingRequestId: UUID!, $commitmentKey: String!) {
  loan: getLoanRecordByFundingRequestAndCommitmentKey(
    fundingRequestId: $fundingRequestId
    commitmentKey: $commitmentKey
  ) {
    ...LoanRecord
  }
}
    ${LoanRecordFragmentDocGQLType}`;

/**
 * __useGetLoanRecordByFundingRequestAndCommitmentKeyQuery__
 *
 * To run a query within a React component, call `useGetLoanRecordByFundingRequestAndCommitmentKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanRecordByFundingRequestAndCommitmentKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanRecordByFundingRequestAndCommitmentKeyQuery({
 *   variables: {
 *      fundingRequestId: // value for 'fundingRequestId'
 *      commitmentKey: // value for 'commitmentKey'
 *   },
 * });
 */
export function useGetLoanRecordByFundingRequestAndCommitmentKeyQuery(baseOptions: Apollo.QueryHookOptions<GetLoanRecordByFundingRequestAndCommitmentKeyQueryGQLType, GetLoanRecordByFundingRequestAndCommitmentKeyQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanRecordByFundingRequestAndCommitmentKeyQueryGQLType, GetLoanRecordByFundingRequestAndCommitmentKeyQueryVariablesGQLType>(GetLoanRecordByFundingRequestAndCommitmentKeyDocumentGQLType, options);
      }
export function useGetLoanRecordByFundingRequestAndCommitmentKeyLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanRecordByFundingRequestAndCommitmentKeyQueryGQLType, GetLoanRecordByFundingRequestAndCommitmentKeyQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanRecordByFundingRequestAndCommitmentKeyQueryGQLType, GetLoanRecordByFundingRequestAndCommitmentKeyQueryVariablesGQLType>(GetLoanRecordByFundingRequestAndCommitmentKeyDocumentGQLType, options);
        }
export type GetLoanRecordByFundingRequestAndCommitmentKeyQueryHookResult = ReturnType<typeof useGetLoanRecordByFundingRequestAndCommitmentKeyQuery>;
export type GetLoanRecordByFundingRequestAndCommitmentKeyLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLoanRecordByFundingRequestAndCommitmentKeyLazyQueryGQLType>;
export type GetLoanRecordByFundingRequestAndCommitmentKeyQueryResultGQLType = Apollo.QueryResult<GetLoanRecordByFundingRequestAndCommitmentKeyQueryGQLType, GetLoanRecordByFundingRequestAndCommitmentKeyQueryVariablesGQLType>;
export const GetResolvedLoanByFundingRequestAndCommitmentKeyDocumentGQLType = gql`
    query getResolvedLoanByFundingRequestAndCommitmentKey($fundingRequestId: UUID!, $commitmentKey: String!) {
  loan: getResolvedLoanByFundingRequestAndCommitmentKey(
    fundingRequestId: $fundingRequestId
    commitmentKey: $commitmentKey
  ) {
    ...ResolvedLoan
  }
}
    ${ResolvedLoanFragmentDocGQLType}`;

/**
 * __useGetResolvedLoanByFundingRequestAndCommitmentKeyQuery__
 *
 * To run a query within a React component, call `useGetResolvedLoanByFundingRequestAndCommitmentKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResolvedLoanByFundingRequestAndCommitmentKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResolvedLoanByFundingRequestAndCommitmentKeyQuery({
 *   variables: {
 *      fundingRequestId: // value for 'fundingRequestId'
 *      commitmentKey: // value for 'commitmentKey'
 *   },
 * });
 */
export function useGetResolvedLoanByFundingRequestAndCommitmentKeyQuery(baseOptions: Apollo.QueryHookOptions<GetResolvedLoanByFundingRequestAndCommitmentKeyQueryGQLType, GetResolvedLoanByFundingRequestAndCommitmentKeyQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResolvedLoanByFundingRequestAndCommitmentKeyQueryGQLType, GetResolvedLoanByFundingRequestAndCommitmentKeyQueryVariablesGQLType>(GetResolvedLoanByFundingRequestAndCommitmentKeyDocumentGQLType, options);
      }
export function useGetResolvedLoanByFundingRequestAndCommitmentKeyLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetResolvedLoanByFundingRequestAndCommitmentKeyQueryGQLType, GetResolvedLoanByFundingRequestAndCommitmentKeyQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResolvedLoanByFundingRequestAndCommitmentKeyQueryGQLType, GetResolvedLoanByFundingRequestAndCommitmentKeyQueryVariablesGQLType>(GetResolvedLoanByFundingRequestAndCommitmentKeyDocumentGQLType, options);
        }
export type GetResolvedLoanByFundingRequestAndCommitmentKeyQueryHookResult = ReturnType<typeof useGetResolvedLoanByFundingRequestAndCommitmentKeyQuery>;
export type GetResolvedLoanByFundingRequestAndCommitmentKeyLazyQueryGQLTypeHookResult = ReturnType<typeof useGetResolvedLoanByFundingRequestAndCommitmentKeyLazyQueryGQLType>;
export type GetResolvedLoanByFundingRequestAndCommitmentKeyQueryResultGQLType = Apollo.QueryResult<GetResolvedLoanByFundingRequestAndCommitmentKeyQueryGQLType, GetResolvedLoanByFundingRequestAndCommitmentKeyQueryVariablesGQLType>;
export const GetAggregateLoansMetadataDocumentGQLType = gql`
    query getAggregateLoansMetadata($filterParams: LoanMetadataFilterParams!) {
  results: getAggregateLoansMetadata(filterParams: $filterParams) {
    totalOutstandingBalance
    totalAccruedInterest
    totalAccruedServiceFees
  }
}
    `;

/**
 * __useGetAggregateLoansMetadataQuery__
 *
 * To run a query within a React component, call `useGetAggregateLoansMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAggregateLoansMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAggregateLoansMetadataQuery({
 *   variables: {
 *      filterParams: // value for 'filterParams'
 *   },
 * });
 */
export function useGetAggregateLoansMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetAggregateLoansMetadataQueryGQLType, GetAggregateLoansMetadataQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAggregateLoansMetadataQueryGQLType, GetAggregateLoansMetadataQueryVariablesGQLType>(GetAggregateLoansMetadataDocumentGQLType, options);
      }
export function useGetAggregateLoansMetadataLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAggregateLoansMetadataQueryGQLType, GetAggregateLoansMetadataQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAggregateLoansMetadataQueryGQLType, GetAggregateLoansMetadataQueryVariablesGQLType>(GetAggregateLoansMetadataDocumentGQLType, options);
        }
export type GetAggregateLoansMetadataQueryHookResult = ReturnType<typeof useGetAggregateLoansMetadataQuery>;
export type GetAggregateLoansMetadataLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAggregateLoansMetadataLazyQueryGQLType>;
export type GetAggregateLoansMetadataQueryResultGQLType = Apollo.QueryResult<GetAggregateLoansMetadataQueryGQLType, GetAggregateLoansMetadataQueryVariablesGQLType>;
export const GetSummarizedLoansDocumentGQLType = gql`
    query getSummarizedLoans($filterParams: LoanMetadataFilterParams!) {
  loans: getSummarizedLoans(filterParams: $filterParams) {
    ...SummarizedLoan
  }
}
    ${SummarizedLoanFragmentDocGQLType}`;

/**
 * __useGetSummarizedLoansQuery__
 *
 * To run a query within a React component, call `useGetSummarizedLoansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSummarizedLoansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSummarizedLoansQuery({
 *   variables: {
 *      filterParams: // value for 'filterParams'
 *   },
 * });
 */
export function useGetSummarizedLoansQuery(baseOptions: Apollo.QueryHookOptions<GetSummarizedLoansQueryGQLType, GetSummarizedLoansQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSummarizedLoansQueryGQLType, GetSummarizedLoansQueryVariablesGQLType>(GetSummarizedLoansDocumentGQLType, options);
      }
export function useGetSummarizedLoansLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetSummarizedLoansQueryGQLType, GetSummarizedLoansQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSummarizedLoansQueryGQLType, GetSummarizedLoansQueryVariablesGQLType>(GetSummarizedLoansDocumentGQLType, options);
        }
export type GetSummarizedLoansQueryHookResult = ReturnType<typeof useGetSummarizedLoansQuery>;
export type GetSummarizedLoansLazyQueryGQLTypeHookResult = ReturnType<typeof useGetSummarizedLoansLazyQueryGQLType>;
export type GetSummarizedLoansQueryResultGQLType = Apollo.QueryResult<GetSummarizedLoansQueryGQLType, GetSummarizedLoansQueryVariablesGQLType>;
export const GetCurrentLiabilityAccountsAndAccrualsForLoanDocumentGQLType = gql`
    query GetCurrentLiabilityAccountsAndAccrualsForLoan($loanId: UUID!, $accrualStartDate: FullDateStr!, $accrualEndDate: FullDateStr!, $inclusiveOfAccrualEndDate: Boolean!) {
  accounts: getCurrentLiabilityAccountsAndAccrualsForLoan(
    loanId: $loanId
    accrualStartDate: $accrualStartDate
    accrualEndDate: $accrualEndDate
    inclusiveOfAccrualEndDate: $inclusiveOfAccrualEndDate
  ) {
    tAccount {
      id
      tAccount
      creditFacilityId
      organizationId
    }
    actualAccruedAmount
    projectedAccruedAmount
    totalAccruedAmount
  }
}
    `;

/**
 * __useGetCurrentLiabilityAccountsAndAccrualsForLoanQuery__
 *
 * To run a query within a React component, call `useGetCurrentLiabilityAccountsAndAccrualsForLoanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentLiabilityAccountsAndAccrualsForLoanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentLiabilityAccountsAndAccrualsForLoanQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      accrualStartDate: // value for 'accrualStartDate'
 *      accrualEndDate: // value for 'accrualEndDate'
 *      inclusiveOfAccrualEndDate: // value for 'inclusiveOfAccrualEndDate'
 *   },
 * });
 */
export function useGetCurrentLiabilityAccountsAndAccrualsForLoanQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentLiabilityAccountsAndAccrualsForLoanQueryGQLType, GetCurrentLiabilityAccountsAndAccrualsForLoanQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentLiabilityAccountsAndAccrualsForLoanQueryGQLType, GetCurrentLiabilityAccountsAndAccrualsForLoanQueryVariablesGQLType>(GetCurrentLiabilityAccountsAndAccrualsForLoanDocumentGQLType, options);
      }
export function useGetCurrentLiabilityAccountsAndAccrualsForLoanLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentLiabilityAccountsAndAccrualsForLoanQueryGQLType, GetCurrentLiabilityAccountsAndAccrualsForLoanQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentLiabilityAccountsAndAccrualsForLoanQueryGQLType, GetCurrentLiabilityAccountsAndAccrualsForLoanQueryVariablesGQLType>(GetCurrentLiabilityAccountsAndAccrualsForLoanDocumentGQLType, options);
        }
export type GetCurrentLiabilityAccountsAndAccrualsForLoanQueryHookResult = ReturnType<typeof useGetCurrentLiabilityAccountsAndAccrualsForLoanQuery>;
export type GetCurrentLiabilityAccountsAndAccrualsForLoanLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCurrentLiabilityAccountsAndAccrualsForLoanLazyQueryGQLType>;
export type GetCurrentLiabilityAccountsAndAccrualsForLoanQueryResultGQLType = Apollo.QueryResult<GetCurrentLiabilityAccountsAndAccrualsForLoanQueryGQLType, GetCurrentLiabilityAccountsAndAccrualsForLoanQueryVariablesGQLType>;
export const GetLenderShareReportsDocumentGQLType = gql`
    query GetLenderShareReports($lenderShareId: UUID!, $fundingRequestComponentId: UUID!) {
  reports: getLenderShareReports(
    lenderShareId: $lenderShareId
    fundingRequestComponentId: $fundingRequestComponentId
  ) {
    ...LenderShareReport
  }
}
    ${LenderShareReportFragmentDocGQLType}`;

/**
 * __useGetLenderShareReportsQuery__
 *
 * To run a query within a React component, call `useGetLenderShareReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLenderShareReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLenderShareReportsQuery({
 *   variables: {
 *      lenderShareId: // value for 'lenderShareId'
 *      fundingRequestComponentId: // value for 'fundingRequestComponentId'
 *   },
 * });
 */
export function useGetLenderShareReportsQuery(baseOptions: Apollo.QueryHookOptions<GetLenderShareReportsQueryGQLType, GetLenderShareReportsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLenderShareReportsQueryGQLType, GetLenderShareReportsQueryVariablesGQLType>(GetLenderShareReportsDocumentGQLType, options);
      }
export function useGetLenderShareReportsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLenderShareReportsQueryGQLType, GetLenderShareReportsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLenderShareReportsQueryGQLType, GetLenderShareReportsQueryVariablesGQLType>(GetLenderShareReportsDocumentGQLType, options);
        }
export type GetLenderShareReportsQueryHookResult = ReturnType<typeof useGetLenderShareReportsQuery>;
export type GetLenderShareReportsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLenderShareReportsLazyQueryGQLType>;
export type GetLenderShareReportsQueryResultGQLType = Apollo.QueryResult<GetLenderShareReportsQueryGQLType, GetLenderShareReportsQueryVariablesGQLType>;
export const GetLenderShareReportsForLoanDocumentGQLType = gql`
    query GetLenderShareReportsForLoan($loanId: UUID!, $fundingRequestId: UUID!) {
  reports: getLenderShareReportsForLoan(
    loanId: $loanId
    fundingRequestId: $fundingRequestId
  ) {
    ...LenderShareReport
  }
}
    ${LenderShareReportFragmentDocGQLType}`;

/**
 * __useGetLenderShareReportsForLoanQuery__
 *
 * To run a query within a React component, call `useGetLenderShareReportsForLoanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLenderShareReportsForLoanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLenderShareReportsForLoanQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      fundingRequestId: // value for 'fundingRequestId'
 *   },
 * });
 */
export function useGetLenderShareReportsForLoanQuery(baseOptions: Apollo.QueryHookOptions<GetLenderShareReportsForLoanQueryGQLType, GetLenderShareReportsForLoanQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLenderShareReportsForLoanQueryGQLType, GetLenderShareReportsForLoanQueryVariablesGQLType>(GetLenderShareReportsForLoanDocumentGQLType, options);
      }
export function useGetLenderShareReportsForLoanLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLenderShareReportsForLoanQueryGQLType, GetLenderShareReportsForLoanQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLenderShareReportsForLoanQueryGQLType, GetLenderShareReportsForLoanQueryVariablesGQLType>(GetLenderShareReportsForLoanDocumentGQLType, options);
        }
export type GetLenderShareReportsForLoanQueryHookResult = ReturnType<typeof useGetLenderShareReportsForLoanQuery>;
export type GetLenderShareReportsForLoanLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLenderShareReportsForLoanLazyQueryGQLType>;
export type GetLenderShareReportsForLoanQueryResultGQLType = Apollo.QueryResult<GetLenderShareReportsForLoanQueryGQLType, GetLenderShareReportsForLoanQueryVariablesGQLType>;
export const GetEarliestOriginationDateForLoansDocumentGQLType = gql`
    query getEarliestOriginationDateForLoans($creditFacilityId: UUID!, $loanIds: [UUID!]!) {
  earliestOriginationDate: getEarliestOriginationDateForLoans(
    creditFacilityId: $creditFacilityId
    loanIds: $loanIds
  )
}
    `;

/**
 * __useGetEarliestOriginationDateForLoansQuery__
 *
 * To run a query within a React component, call `useGetEarliestOriginationDateForLoansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEarliestOriginationDateForLoansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEarliestOriginationDateForLoansQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      loanIds: // value for 'loanIds'
 *   },
 * });
 */
export function useGetEarliestOriginationDateForLoansQuery(baseOptions: Apollo.QueryHookOptions<GetEarliestOriginationDateForLoansQueryGQLType, GetEarliestOriginationDateForLoansQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEarliestOriginationDateForLoansQueryGQLType, GetEarliestOriginationDateForLoansQueryVariablesGQLType>(GetEarliestOriginationDateForLoansDocumentGQLType, options);
      }
export function useGetEarliestOriginationDateForLoansLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetEarliestOriginationDateForLoansQueryGQLType, GetEarliestOriginationDateForLoansQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEarliestOriginationDateForLoansQueryGQLType, GetEarliestOriginationDateForLoansQueryVariablesGQLType>(GetEarliestOriginationDateForLoansDocumentGQLType, options);
        }
export type GetEarliestOriginationDateForLoansQueryHookResult = ReturnType<typeof useGetEarliestOriginationDateForLoansQuery>;
export type GetEarliestOriginationDateForLoansLazyQueryGQLTypeHookResult = ReturnType<typeof useGetEarliestOriginationDateForLoansLazyQueryGQLType>;
export type GetEarliestOriginationDateForLoansQueryResultGQLType = Apollo.QueryResult<GetEarliestOriginationDateForLoansQueryGQLType, GetEarliestOriginationDateForLoansQueryVariablesGQLType>;
export const GetBatchSettlementsForCreditFacilityDocumentGQLType = gql`
    query getBatchSettlementsForCreditFacility($creditFacilityId: UUID!, $lenderIds: [UUID!], $loanIds: [UUID!]) {
  settlements: getBatchSettlementsForCreditFacility(
    creditFacilityId: $creditFacilityId
    lenderIds: $lenderIds
    loanIds: $loanIds
  ) {
    ...BatchSettlement
  }
}
    ${BatchSettlementFragmentDocGQLType}`;

/**
 * __useGetBatchSettlementsForCreditFacilityQuery__
 *
 * To run a query within a React component, call `useGetBatchSettlementsForCreditFacilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBatchSettlementsForCreditFacilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBatchSettlementsForCreditFacilityQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      lenderIds: // value for 'lenderIds'
 *      loanIds: // value for 'loanIds'
 *   },
 * });
 */
export function useGetBatchSettlementsForCreditFacilityQuery(baseOptions: Apollo.QueryHookOptions<GetBatchSettlementsForCreditFacilityQueryGQLType, GetBatchSettlementsForCreditFacilityQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBatchSettlementsForCreditFacilityQueryGQLType, GetBatchSettlementsForCreditFacilityQueryVariablesGQLType>(GetBatchSettlementsForCreditFacilityDocumentGQLType, options);
      }
export function useGetBatchSettlementsForCreditFacilityLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetBatchSettlementsForCreditFacilityQueryGQLType, GetBatchSettlementsForCreditFacilityQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBatchSettlementsForCreditFacilityQueryGQLType, GetBatchSettlementsForCreditFacilityQueryVariablesGQLType>(GetBatchSettlementsForCreditFacilityDocumentGQLType, options);
        }
export type GetBatchSettlementsForCreditFacilityQueryHookResult = ReturnType<typeof useGetBatchSettlementsForCreditFacilityQuery>;
export type GetBatchSettlementsForCreditFacilityLazyQueryGQLTypeHookResult = ReturnType<typeof useGetBatchSettlementsForCreditFacilityLazyQueryGQLType>;
export type GetBatchSettlementsForCreditFacilityQueryResultGQLType = Apollo.QueryResult<GetBatchSettlementsForCreditFacilityQueryGQLType, GetBatchSettlementsForCreditFacilityQueryVariablesGQLType>;
export const MarkLenderShareComponentFundTransferDateDocumentGQLType = gql`
    mutation MarkLenderShareComponentFundTransferDate($lenderShareId: UUID!, $fundingRequestComponentId: UUID!, $fundTransferDate: FullDateStr) {
  markLenderShareComponentFundTransferDate(
    lenderShareId: $lenderShareId
    fundingRequestComponentId: $fundingRequestComponentId
    fundTransferDate: $fundTransferDate
  )
}
    `;
export type MarkLenderShareComponentFundTransferDateMutationFnGQLType = Apollo.MutationFunction<MarkLenderShareComponentFundTransferDateMutationGQLType, MarkLenderShareComponentFundTransferDateMutationVariablesGQLType>;

/**
 * __useMarkLenderShareComponentFundTransferDateMutation__
 *
 * To run a mutation, you first call `useMarkLenderShareComponentFundTransferDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkLenderShareComponentFundTransferDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markLenderShareComponentFundTransferDateMutation, { data, loading, error }] = useMarkLenderShareComponentFundTransferDateMutation({
 *   variables: {
 *      lenderShareId: // value for 'lenderShareId'
 *      fundingRequestComponentId: // value for 'fundingRequestComponentId'
 *      fundTransferDate: // value for 'fundTransferDate'
 *   },
 * });
 */
export function useMarkLenderShareComponentFundTransferDateMutation(baseOptions?: Apollo.MutationHookOptions<MarkLenderShareComponentFundTransferDateMutationGQLType, MarkLenderShareComponentFundTransferDateMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkLenderShareComponentFundTransferDateMutationGQLType, MarkLenderShareComponentFundTransferDateMutationVariablesGQLType>(MarkLenderShareComponentFundTransferDateDocumentGQLType, options);
      }
export type MarkLenderShareComponentFundTransferDateMutationHookResult = ReturnType<typeof useMarkLenderShareComponentFundTransferDateMutation>;
export type MarkLenderShareComponentFundTransferDateMutationResultGQLType = Apollo.MutationResult<MarkLenderShareComponentFundTransferDateMutationGQLType>;
export type MarkLenderShareComponentFundTransferDateMutationOptionsGQLType = Apollo.BaseMutationOptions<MarkLenderShareComponentFundTransferDateMutationGQLType, MarkLenderShareComponentFundTransferDateMutationVariablesGQLType>;
export const UpdateLoanExternalLoanIdDocumentGQLType = gql`
    mutation updateLoanExternalLoanId($loanId: UUID!, $newExternalLoanId: String) {
  updateLoanExternalLoanId(loanId: $loanId, newExternalLoanId: $newExternalLoanId) {
    ...LoanRecord
  }
}
    ${LoanRecordFragmentDocGQLType}`;
export type UpdateLoanExternalLoanIdMutationFnGQLType = Apollo.MutationFunction<UpdateLoanExternalLoanIdMutationGQLType, UpdateLoanExternalLoanIdMutationVariablesGQLType>;

/**
 * __useUpdateLoanExternalLoanIdMutation__
 *
 * To run a mutation, you first call `useUpdateLoanExternalLoanIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLoanExternalLoanIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLoanExternalLoanIdMutation, { data, loading, error }] = useUpdateLoanExternalLoanIdMutation({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      newExternalLoanId: // value for 'newExternalLoanId'
 *   },
 * });
 */
export function useUpdateLoanExternalLoanIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLoanExternalLoanIdMutationGQLType, UpdateLoanExternalLoanIdMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLoanExternalLoanIdMutationGQLType, UpdateLoanExternalLoanIdMutationVariablesGQLType>(UpdateLoanExternalLoanIdDocumentGQLType, options);
      }
export type UpdateLoanExternalLoanIdMutationHookResult = ReturnType<typeof useUpdateLoanExternalLoanIdMutation>;
export type UpdateLoanExternalLoanIdMutationResultGQLType = Apollo.MutationResult<UpdateLoanExternalLoanIdMutationGQLType>;
export type UpdateLoanExternalLoanIdMutationOptionsGQLType = Apollo.BaseMutationOptions<UpdateLoanExternalLoanIdMutationGQLType, UpdateLoanExternalLoanIdMutationVariablesGQLType>;
export const CreateBatchSettlementDocumentGQLType = gql`
    mutation createBatchSettlement($creditFacilityId: UUID!, $lenderIds: [UUID!]!, $loanIds: [UUID!]!, $startDate: FullDateStr!, $endDate: FullDateStr!) {
  createBatchSettlement(
    creditFacilityId: $creditFacilityId
    lenderIds: $lenderIds
    loanIds: $loanIds
    startDate: $startDate
    endDate: $endDate
  ) {
    batchSettlementId
    workleaseId
  }
}
    `;
export type CreateBatchSettlementMutationFnGQLType = Apollo.MutationFunction<CreateBatchSettlementMutationGQLType, CreateBatchSettlementMutationVariablesGQLType>;

/**
 * __useCreateBatchSettlementMutation__
 *
 * To run a mutation, you first call `useCreateBatchSettlementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBatchSettlementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBatchSettlementMutation, { data, loading, error }] = useCreateBatchSettlementMutation({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      lenderIds: // value for 'lenderIds'
 *      loanIds: // value for 'loanIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useCreateBatchSettlementMutation(baseOptions?: Apollo.MutationHookOptions<CreateBatchSettlementMutationGQLType, CreateBatchSettlementMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBatchSettlementMutationGQLType, CreateBatchSettlementMutationVariablesGQLType>(CreateBatchSettlementDocumentGQLType, options);
      }
export type CreateBatchSettlementMutationHookResult = ReturnType<typeof useCreateBatchSettlementMutation>;
export type CreateBatchSettlementMutationResultGQLType = Apollo.MutationResult<CreateBatchSettlementMutationGQLType>;
export type CreateBatchSettlementMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateBatchSettlementMutationGQLType, CreateBatchSettlementMutationVariablesGQLType>;